import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGIN } from "@/constants/testIds";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState(localStorage.getItem("remember_email") || "");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(!!localStorage.getItem("remember_email"));
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      if (remember) localStorage.setItem("remember_email", email);
      else localStorage.removeItem("remember_email");
      navigate("/");
    }
    else setError(res.error);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-secondary">
      {/* LADO IZQUIERDO: Imagen y Branding (Solo Desktop) */}
      <div className="hidden lg:block relative bg-navy">
        <img
          src="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHx3YXJlaG91c2UlMjBsb2dpc3RpY3N8ZW58MHx8fHwxNzgyNjgzMTEwfDA&ixlib=rb-4.1.0&q=85"
          alt="Almacén logístico"
          className="absolute inset-0 w-full h-full object-cover opacity-20"
        />
        <div className="relative z-10 p-12 flex flex-col justify-between h-full text-white">
          <div className="flex flex-col items-start">
             {/* Logo NAF Estilizado */}
             <div className="bg-[#002060] w-48 h-12 flex items-center px-4 rounded-[2px] mb-2 border border-white/20">
                <span className="text-2xl font-bold tracking-tighter leading-none">NAF</span>
                <div className="flex-1 h-[2px] bg-white ml-3" />
             </div>
             <p className="text-sm font-medium tracking-tight text-white/90">North America Flooring</p>
          </div>

          <div>
            <h1 className="font-heading text-4xl font-extrabold leading-tight tracking-tight">
              Sistema Integral de Seguridad Patrimonial
            </h1>
            <p className="mt-4 text-white/70 max-w-md">
              Control de accesos, bitácoras automáticas y rondas de seguridad en una sola plataforma.
            </p>
          </div>
        </div>
      </div>

      {/* LADO DERECHO: Formulario de Login */}
      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          {/* Logo visible en móvil */}
          <div className="lg:hidden flex flex-col items-center mb-8">
            <div className="bg-[#002060] w-48 h-12 flex items-center px-4 rounded-[2px] mb-2 shadow-md">
              <span className="text-2xl font-bold tracking-tighter leading-none text-white">NAF</span>
              <div className="flex-1 h-[2px] bg-white ml-3" />
            </div>
            <p className="text-xs font-bold text-navy tracking-widest uppercase">Seguridad Patrimonial</p>
          </div>

          <div className="bg-white p-8 border border-border shadow-sm">
            <h2 className="font-heading text-2xl font-extrabold tracking-tight text-navy">Iniciar sesión</h2>
            <p className="text-sm text-muted-foreground mt-1 mb-6">Ingresa tus credenciales para acceder.</p>

            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-1.5">
                <label htmlFor="email" className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Usuario / Email</label>
                <input
                  id="email"
                  type="email"
                  data-testid={LOGIN.emailInput}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full h-11 px-3 border border-border bg-secondary/30 text-navy focus:outline-none focus:border-navy transition-colors"
                  placeholder="admin@sisp.com"
                />
              </div>
              <div className="space-y-1.5">
                <label htmlFor="password" className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Contraseña</label>
                <input
                  id="password"
                  type="password"
                  data-testid={LOGIN.passwordInput}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full h-11 px-3 border border-border bg-secondary/30 text-navy focus:outline-none focus:border-navy transition-colors"
                  placeholder="••••••••"
                />
              </div>

              <div className="flex items-center justify-between">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={remember}
                    onChange={(e) => setRemember(e.target.checked)}
                    className="w-4 h-4 border-border rounded accent-navy"
                  />
                  <span className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Recordar usuario</span>
                </label>
              </div>

              {error && (
                <div className="border-l-4 border-critical bg-critical/5 text-critical px-3 py-2 text-xs font-medium">
                  {error}
                </div>
              )}

              <button
                type="submit"
                data-testid={LOGIN.submitButton}
                disabled={loading}
                className="w-full h-12 bg-navy text-white font-bold hover:bg-navy-hover transition-all active:scale-[0.98] disabled:opacity-50 shadow-md"
              >
                {loading ? "VERIFICANDO…" : "ACCEDER"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
